// extracted by mini-css-extract-plugin
module.exports = {"inner":"secondary-page-module--inner--301Uq","pageTitle":"secondary-page-module--pageTitle--34z68"};